import React from "react";

export const Tile = ({ style, children, onClick, onDoubleClick, ...rest }) => {
  return (
    <div
      style={{
        // borderRadius: "5%",
        padding: "0.5rem",
        display: "flex",
        justifyContent: "center",
        backgroundColor: "blanchedalmond",
        border: "1px solid gray",
        minHeight: "40px",
        textAlign: "center",
        fontWeight: "bold",
        maxWidth: "100%",
        userSelect: "none",
        ...style,
      }}
      onClick={onClick}
      onDoubleClick={onDoubleClick}
      {...rest}
    >
      {children}
    </div>
  );
};
